const initialState = () => ({
  assigned_products: [],
})

export default initialState
